module.exports = __webpack_public_path__ + "static/img/b2.eb5bade.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b2.jpg
// module id = 247
// module chunks = 0 1 2 3 4 5 6 7 8 9